import { IEdgeData } from "components/CurrentNewTree/type"

export const getChildEdgeData = ({ sourceId, targetId, pos }: IEdgeData) => (
    {
        type: 'smoothstep',
        sourceHandle: 'SourceTop',
        targetHandle: 'TarBottom',
        source: sourceId,
        target: targetId,
    }
)